import { DynamicComponentManifest } from './../dynamic-component-loader/dynamic-component-manifest';
import { Countries } from './countries-enum';
import '../string.extensions';

export class DynamicArrayGenerator {
  loadChildrenHKG: string = '';
  loadChildrenSGP: string = '';
  loadChildrenKOR: string = '';
  loadChildrenJPA: string = '';
  loadChildrenIND: string = '';
  loadChildrenCHN: string = '';
  loadChildrenNZL: string = '';
  loadChildrenAUS: string = '';
  loadChildrenTWN: string = '';
  loadChildrenTHA: string = '';
  loadChildrenPHL: string = '';
  loadChildrenVNM: string = '';
  loadChildrenIDN: string = '';
  globalModule: string = '';

  constructor() {
    this.loadChildrenHKG = './modules/countries/HKG/hongkong.module#HongkongModule';
    this.loadChildrenJPA = './modules/countries/JPN/japan.module#JapanModule';
    this.loadChildrenSGP = './modules/countries/SGP/singapore.module#SingaporeModule';
    this.loadChildrenKOR = './modules/countries/KOR/korea.module#KoreaModule';
    this.loadChildrenIND = './modules/countries/IND/india.module#IndiaModule';
    this.loadChildrenCHN = './modules/countries/CHN/china.module#ChinaModule';
    this.loadChildrenNZL = './modules/countries/NZL/newzealand.module#NewzealandModule';
    this.loadChildrenAUS = './modules/countries/AUS/australia.module#AustraliaModule';
    this.loadChildrenTWN = './modules/countries/TWN/taiwan.module#TaiwanModule';
    this.loadChildrenTHA = './modules/countries/THA/thailand.module#ThailandModule';
    this.loadChildrenPHL = './modules/countries/PHL/philippines.module#PhilippinesModule';
    this.loadChildrenVNM = './modules/countries/VNM/vietnam.module#VietnamModule';
    this.loadChildrenIDN = './modules/countries/IDN/indonesia.module#IndonesiaModule';
  }

  public generateManifest(listofComponents: any[], country: string): DynamicComponentManifest[] {
    const componentManifest: DynamicComponentManifest[] = [];
    if (listofComponents && listofComponents.length > 0) {
      listofComponents.forEach(component => {
        if (component) {
          switch (country) {
            // tslint:disable-next-line: no-use-before-declare
            case Countries.Japan:
              componentManifest.push(this.generateArray(country, this.loadChildrenJPA, component));
              break;
            // tslint:disable-next-line: no-use-before-declare
            case Countries.Hongkong:
              componentManifest.push(this.generateArray(country, this.loadChildrenHKG, component));
              break;
            // tslint:disable-next-line: no-use-before-declare
            case Countries.Singapore:
              componentManifest.push(this.generateArray(country, this.loadChildrenSGP, component));
              break;
            case Countries.Thailand:
              componentManifest.push(this.generateArray(country, this.loadChildrenTHA, component));
              break;
            case Countries.Philippines:
              componentManifest.push(this.generateArray(country, this.loadChildrenPHL, component));
              break;
            case Countries.Vietnam:
              componentManifest.push(this.generateArray(country, this.loadChildrenVNM, component));
              break;
            case Countries.Korea:
              componentManifest.push(this.generateArray(country, this.loadChildrenKOR, component));
              break;
            case Countries.India:
              componentManifest.push(this.generateArray(country, this.loadChildrenIND, component));
              break;
            case Countries.China:
              componentManifest.push(this.generateArray(country, this.loadChildrenCHN, component));
              break;
            case Countries.Australia:
              componentManifest.push(this.generateArray(country, this.loadChildrenAUS, component));
              break;
            case Countries.NewZealand:
              componentManifest.push(this.generateArray(country, this.loadChildrenNZL, component));
              break;
            case Countries.Taiwan:
              componentManifest.push(this.generateArray(country, this.loadChildrenTWN, component));
              break;
            case Countries.Indonesia:
              componentManifest.push(this.generateArray(country, this.loadChildrenIDN, component));
              break;
            default:
              console.warn(`Dynamic Array Generator: Country ${country} not found when generating the manifest!`);
              break;
          }
        }
      });
    }
    return componentManifest;
  }

  private generateArray(country: string, loadchildren: string, component: any) {
    const moduleFolder = component.module === 'GlobalModule' ? 'global' : country.toUpperCase();
    return {
      componentId: `${country}-${component.key}`,
      componentName: `${component.key.toPascalCase()}Component`,
      path: `${country.toLocaleLowerCase()}-${component.key}`,
      loadChildren: component.module === 'GlobalModule' ? this.globalModule : loadchildren,
      loadComponent: `${moduleFolder}/components/${component.key}/${component.key}.component`
    };
  }
}
